import { render, staticRenderFns } from "./Nuovo.vue?vue&type=template&id=93b28412&scoped=true"
import script from "./Nuovo.vue?vue&type=script&lang=js"
export * from "./Nuovo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b28412",
  null
  
)

export default component.exports